import { render } from "./GeolocationDetails.vue?vue&type=template&id=289d4d28"
import script from "./GeolocationDetails.vue?vue&type=script&lang=js"
export * from "./GeolocationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__